import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { PageTitle, ButtonsSection } from 'components/PortalStructure';
import { WhiteButton } from 'components';
import { browserHistory } from 'react-router';
import { IUserLanguage } from 'models/user/userlanguage';
import { ILanguage } from 'models/common';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';

require('./style.css');

interface IProps {
	userLanguage?: IUserLanguage;
	languageDomainValues?: ILanguage[];
	/* functions props */
	t?: (key: string, options?: any) => string;
}

@connect(
	(state: IStore) => ({
		languageDomainValues: state.domainValues.languages,
		userLanguage: state.userLanguage,
	}),
	(dispatch) => ({
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class EmptyShoppingBag extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { t } = this.props;

		const culture = this.props.userLanguage.culture;
		const homeLink = '/home/' + culture.substring(0, 2);

		return (
			<>
				<PageTitle title={t('Cart_ShoppingBag_Label_ShoppingBag')} />
				<div className="emptyShoppingBagContainer">
					<div className="emptyShoppingBagHeight">
						<div>
							<span className="text">{t('Cart_EmptyShoppingBag_NoItemsInBag')}</span>
						</div>
					</div>
					<ButtonsSection>
						<div className="row">
							<div className="col-sm-12">
								<div className="floatRight">
									<WhiteButton
										type="button"
										onClick={() => {
											browserHistory.push(homeLink);
										}}
									>
										{t('Cart_ShoppingBag_Button_ContinueShopping')}
									</WhiteButton>
									<div className="clear" />
								</div>
								<div className="clear" />
							</div>
						</div>
					</ButtonsSection>
				</div>
			</>
		);
	}
}

export { EmptyShoppingBag };
